import { noop } from 'lodash';

import { rem } from '@blueprint/ui';

import { Text } from 'components/blueprint';

import { ActionLabelPill, ActionPillWrapper } from '../ActionPillWrapper';

export const QuickReplySurverActions = ({
  isFeedbackEnable,
  content,
  answer,
}) => {
  /**
   * action to the survey button click
   */
  const handleReplyAction = (e, { action, payload, text }) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isFeedbackEnable) {
      return noop;
    }

    action && action({ message: payload });
  };

  return (
    <ActionPillWrapper>
      {content.map((item, index) => (
        <ActionLabelPill
          key={`${item.text}-${index}`}
          tabIndex={isFeedbackEnable ? '0' : '-1'}
          disabled={!isFeedbackEnable}
          onClick={(e) => handleReplyAction(e, item)}
          aria-label={`${answer} ${item.text}`}
          marginRight={rem(5)}
        >
          <Text>{item.text}</Text>
        </ActionLabelPill>
      ))}
    </ActionPillWrapper>
  );
};
